import { render } from "./candidate.vue?vue&type=template&id=900c24b0&ts=true"
import script from "./candidate.vue?vue&type=script&lang=ts"
export * from "./candidate.vue?vue&type=script&lang=ts"

import "./candidate.vue?vue&type=style&index=0&id=900c24b0&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__